import { render, staticRenderFns } from "./CalendarEventAddNote.vue?vue&type=template&id=d4dc10ae&scoped=true"
import script from "./CalendarEventAddNote.vue?vue&type=script&lang=js"
export * from "./CalendarEventAddNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc10ae",
  null
  
)

export default component.exports